import { motion } from 'framer-motion';
import { Phone, MessageCircle } from 'lucide-react';
import { contactInfo } from '../data/services';

export const FloatingButtons = () => {
  return (
    <div className="floating-buttons" data-testid="floating-buttons">
      {/* WhatsApp Button */}
      <motion.a
        href={`https://wa.me/${contactInfo.whatsapp}?text=Hi, I would like to inquire about your services.`}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-btn w-14 h-14 rounded-full flex items-center justify-center shadow-lg"
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 1, type: 'spring', stiffness: 200 }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        data-testid="floating-whatsapp-btn"
      >
        <MessageCircle size={24} className="text-white" />
      </motion.a>

      {/* Call Button */}
      <motion.a
        href={`tel:+91${contactInfo.phone}`}
        className="call-btn w-14 h-14 rounded-full flex items-center justify-center shadow-lg animate-pulse-glow"
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 1.2, type: 'spring', stiffness: 200 }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        data-testid="floating-call-btn"
      >
        <Phone size={24} className="text-white" />
      </motion.a>
    </div>
  );
};
